export const tabs = [
  { label: '化学战剂', mod: 'cwaMod' },
  { label: '有毒有害易燃气体', mod: 'tvocMod' },
  { label: '烟雾', mod: 'smokeMod' },
  { label: '生物因子', mod: 'bioMod' },
  { label: '核检测', mod: 'nuclearMod' },
  { label: '气象信息', mod: 'weatherMod' },
  { label: '设备状态', mod: 'deviceMod' }
];

export const chartColors = [
  '#6A8CAF',
  '#3FC5F0',
  '#6DECB9',
  '#42DEE1',
  '#728ee8',
  '#296eb3',
  '#00e1f3',
  '#6a77af'
];

export function makeOption({ data, color, unit }) {
  return {
    color: [color],
    tooltip: { trigger: 'axis' },
    backgroundColor: '#112132',
    textStyle: { color },
    grid: {
      left: '5%',
      right: '5%',
      top: '15%',
      bottom: '5%',
      containLabel: true
    },
    dataZoom: [{ type: 'inside' }],
    xAxis: {
      type: 'time',
      axisLine: { lineStyle: { color: '#d8dde6' } },
      splitLine: { lineStyle: { color: '#727a83' } }
    },
    yAxis: {
      name: unit,
      type: 'value',
      axisLine: { lineStyle: { color: '#d8dde6' } },
      splitLine: { lineStyle: { color: '#727a83' } },
      max(v) {
        if (v.max < 0) {
          return v.max / 2;
        }
        if (v.max == 0) {
          return v.max + 0.0001;
        }
        return v.max < 100 ? 2 * v.max : v.max + 100;
      }
    },
    series: [
      {
        type: 'line',
        symbol: 'roundRect',
        symbolSize: 6,
        smooth: true,
        markPoint: {
          label: { color: '#fff' },
          data: [
            { type: 'max', name: '最大值' },
            { type: 'min', name: '最小值' }
          ]
        },
        data
      }
    ]
  };
}
